import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { StyledBigHeaderH2, StyledParagraphSmall } from "../Typography"
import { Col, Container, Row, Visible } from "react-grid-system"
import { Fade } from "react-reveal"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"
import report from "../../downloads/abcworld-impact-report-2020.pdf"

const StyledCaseStudiesHeaderTextWrapper = styled.div`
  margin-bottom: 13%;

  ${breakpoint.md} {
    margin-bottom: 10%;
  }

  ${breakpoint.lg} {
    margin-bottom: 8%;
  }

  ${breakpoint.xl} {
    margin-bottom: 6%;
  }
`

const StyledCaseStudiesColItemWrapper = styled.div`
  width: 100%;

  ${breakpoint.lg} {
    width: 48%;
  }
`

const StyledBigHeaderH2Wrapper = styled.div`
  margin-bottom: 12px;

  ${breakpoint.md} {
    margin-bottom: 2%;
  }
  ${breakpoint.lg} {
    margin-bottom: 3%;
  }
`

const StyledLogoRowWrapper = styled.div`
  margin-bottom: 4%;

  ${breakpoint.lg} {
    margin-bottom: 2.5%;
  }
`

const StyledPictureAndDescriptionRowWrapper = styled.div`
  margin-bottom: 8%;

  ${breakpoint.lg} {
    margin-bottom: 5%;
  }
`

const StyledSingleCaseStudyMobileWrapper = styled.div`
  margin-bottom: 50px;
`

const StyledGeographyLinesAbsoluteContainer = styled.div`
  position: absolute;
  z-index: 1;
  width: 100%;
  overflow-x: hidden;
  top: -30%;

  ${breakpoint.lg} {
    top: -15%;
  }
`

const StyledGeographyLinesWrapper = styled.div`
  position: relative;
  width: 70%;
  right: -50%;

  ${breakpoint.lg} {
    width: 50%;
    right: -53%;
  }
  ${breakpoint.xl} {
    width: 45%;
    max-width: 750px;
    right: -60%;
  }
`

const StyledSpecialDownloadAnchor = styled.a`
  color: #414042;
  cursor: pointer;

  &:visited {
    color: #414042;
  }

  &:active,
  &:hover {
    color: #7d7d7d;
  }
`

const CaseStudiesSection = () => {
  return (
    <section style={{ position: "relative" }}>
      <div style={{ position: "relative", zIndex: 3, overflowX: "hidden" }}>
        <StyledCaseStudiesHeaderTextWrapper>
          <Container fluid xs sm md>
            <Row>
              <Col xs={12}>
                <StyledCaseStudiesColItemWrapper>
                  <Fade ssrReveal>
                    <StyledBigHeaderH2Wrapper>
                      <Visible xs sm md>
                        <StyledBigHeaderH2>Case Studies</StyledBigHeaderH2>
                      </Visible>
                      <Visible lg xl xxl>
                        <StyledBigHeaderH2>
                          Case <br />
                          Studies
                        </StyledBigHeaderH2>
                      </Visible>
                    </StyledBigHeaderH2Wrapper>
                    <Visible xs sm md>
                      <StyledParagraphSmall style={{ margin: "0" }}>
                        Our case studies illustrate how our assessment framework
                        is applied to gauge the impact potential of our
                        investments. They help to contextualise the process of
                        evaluation for each impact dimension.
                        <br />
                        <br />
                        Please download our Impact Report 2020 for the complete
                        individual case studies{" "}
                        <StyledSpecialDownloadAnchor
                          href={report}
                          download="ABC World Impact Report 2020"
                        >
                          <u>here</u>
                        </StyledSpecialDownloadAnchor>
                        .
                      </StyledParagraphSmall>
                    </Visible>
                    <Visible lg xl xxl>
                      <StyledParagraphSmall style={{ margin: "0" }}>
                        Our case studies illustrate how our assessment framework
                        is applied to gauge the impact potential of our
                        investments. They help to contextualise the process of
                        evaluation for each impact dimension. Please download
                        our Impact Report 2020 for the complete individual case
                        studies{" "}
                        <StyledSpecialDownloadAnchor
                          href={report}
                          download="ABC World Impact Report 2020"
                        >
                          <u>here</u>
                        </StyledSpecialDownloadAnchor>
                        .
                      </StyledParagraphSmall>
                    </Visible>
                  </Fade>
                </StyledCaseStudiesColItemWrapper>
              </Col>
            </Row>
          </Container>
        </StyledCaseStudiesHeaderTextWrapper>
        <Visible xs sm md>
          <Container fluid xs sm md>
            <Row gutterWidth={200}>
              <Col xs={12} lg={6}>
                <StyledSingleCaseStudyMobileWrapper>
                  <Fade ssrReveal left>
                    <StyledLogoRowWrapper>
                      <div style={{ maxWidth: "50%" }}>
                        <StaticImage
                          src="../../images/cropin-logo.png"
                          alt="cropIn"
                          height={185}
                        />
                      </div>
                    </StyledLogoRowWrapper>
                    <StaticImage
                      src="../../images/two-men-using-ipad.png"
                      alt="two people using ipad"
                      layout="fullWidth"
                    />
                    <StyledParagraphSmall>
                      CropIn provides data-driven solutions that improve the
                      productivity and livelihood of smallholder farmers,
                      driving greater efficiency in agri supply-chains and
                      improving sustainability of the food system.
                    </StyledParagraphSmall>
                  </Fade>
                </StyledSingleCaseStudyMobileWrapper>
              </Col>
              <Col xs={12} lg={6}>
                <StyledSingleCaseStudyMobileWrapper>
                  <Fade ssrReveal right>
                    <StyledLogoRowWrapper>
                      <div style={{ maxWidth: "50%" }}>
                        <StaticImage
                          src="../../images/kim-dental-logo.png"
                          alt="kim dental"
                        />
                      </div>
                    </StyledLogoRowWrapper>
                    <StaticImage
                      src="../../images/dental-surgery.png"
                      alt="dentist working on a patient"
                      layout="fullWidth"
                    />
                    <StyledParagraphSmall>
                      Kim Dental contributes to better healthcare by increasing
                      access to oral healthcare services and prevention efforts
                      in Vietnam, thereby reducing the risks of oral and
                      non-commmunicable diseases in the population.
                    </StyledParagraphSmall>
                  </Fade>
                </StyledSingleCaseStudyMobileWrapper>
              </Col>
            </Row>
            <StyledLogoRowWrapper>
              <Row align="end" gutterWidth={200}>
                <Col xs={12} lg={6}>
                  <Fade ssrReveal left></Fade>
                </Col>
                <Col xs={12} lg={6}>
                  <Fade ssrReveal right></Fade>
                </Col>
              </Row>
            </StyledLogoRowWrapper>
            <Row gutterWidth={200}>
              <Col xs={12} lg={6}>
                <StyledSingleCaseStudyMobileWrapper>
                  <Fade ssrReveal left delay={300}>
                    <StyledLogoRowWrapper>
                      <div style={{ maxWidth: "50%" }}>
                        <StaticImage
                          src="../../images/v2-food-logo.png"
                          alt="v2 food"
                          height={185}
                        />
                      </div>
                    </StyledLogoRowWrapper>
                    <StaticImage
                      src="../../images/two-people-farming.png"
                      alt="two people farming"
                      layout="fullWidth"
                    />
                    <StyledParagraphSmall>
                      v2food’s products accelerate consumers’ transition to a
                      more plant-rich diet and reduces greenhouse gas emissions,
                      water use and land use in our environment.
                    </StyledParagraphSmall>
                  </Fade>
                </StyledSingleCaseStudyMobileWrapper>
              </Col>
              <Col xs={12} lg={6}>
                <StyledSingleCaseStudyMobileWrapper>
                  <Fade ssrReveal right delay={300}>
                    <StyledLogoRowWrapper>
                      <div style={{ maxWidth: "50%" }}>
                        <StaticImage
                          src="../../images/cd-finance-logo.png"
                          alt="cd finance"
                        />
                      </div>
                    </StyledLogoRowWrapper>
                    <StaticImage
                      src="../../images/old-man-using-phone.png"
                      alt="old man using phone"
                      layout="fullWidth"
                    />

                    <StyledParagraphSmall>
                      CD Finance supports financial inclusion by providing
                      access to safe and affordable financial solutions to rural
                      communities in China.
                    </StyledParagraphSmall>
                  </Fade>
                </StyledSingleCaseStudyMobileWrapper>
              </Col>
            </Row>
          </Container>
        </Visible>
        <Visible lg xl xxl>
          <Container fluid xs sm md>
            <StyledLogoRowWrapper>
              <Row align="end" gutterWidth={200}>
                <Col xs={12} lg={6}>
                  <Fade ssrReveal left>
                    <div style={{ maxWidth: "50%" }}>
                      <StaticImage
                        src="../../images/cropin-logo.png"
                        alt="cropIn"
                        height={185}
                      />
                    </div>
                  </Fade>
                </Col>
                <Col xs={12} lg={6}>
                  <Fade ssrReveal right>
                    <div style={{ maxWidth: "50%" }}>
                      <StaticImage
                        src="../../images/kim-dental-logo.png"
                        alt="kim dental"
                      />
                    </div>
                  </Fade>
                </Col>
              </Row>
            </StyledLogoRowWrapper>
            <StyledPictureAndDescriptionRowWrapper>
              <Row gutterWidth={200}>
                <Col xs={12} lg={6}>
                  <Fade ssrReveal left>
                    <StaticImage
                      src="../../images/two-men-using-ipad.png"
                      alt="two people using ipad"
                      layout="fullWidth"
                    />
                    <StyledParagraphSmall>
                      CropIn provides data-driven solutions that improve the
                      productivity and livelihood of smallholder farmers,
                      driving greater efficiency in agri supply-chains and
                      improving sustainability of the food system.
                    </StyledParagraphSmall>
                  </Fade>
                </Col>
                <Col xs={12} lg={6}>
                  <Fade ssrReveal right>
                    <StaticImage
                      src="../../images/dental-surgery.png"
                      alt="dentist working on a patient"
                      layout="fullWidth"
                    />
                    <StyledParagraphSmall>
                      Kim Dental contributes to better healthcare by increasing
                      access to oral healthcare services and prevention efforts
                      in Vietnam, thereby reducing the risks of oral and
                      non-commmunicable diseases in the population.
                    </StyledParagraphSmall>
                  </Fade>
                </Col>
              </Row>
            </StyledPictureAndDescriptionRowWrapper>
            <StyledLogoRowWrapper>
              <Row align="end" gutterWidth={200}>
                <Col xs={12} lg={6}>
                  <Fade ssrReveal left>
                    <div style={{ maxWidth: "50%" }}>
                      <StaticImage
                        src="../../images/v2-food-logo.png"
                        alt="v2 food"
                        height={185}
                      />
                    </div>
                  </Fade>
                </Col>
                <Col xs={12} lg={6}>
                  <Fade ssrReveal right>
                    <div style={{ maxWidth: "50%" }}>
                      <StaticImage
                        src="../../images/cd-finance-logo.png"
                        alt="cd finance"
                      />
                    </div>
                  </Fade>
                </Col>
              </Row>
            </StyledLogoRowWrapper>
            <Row gutterWidth={200}>
              <Col xs={12} lg={6}>
                <Fade ssrReveal left delay={300}>
                  <StaticImage
                    src="../../images/two-people-farming.png"
                    alt="two people farming"
                    layout="fullWidth"
                  />
                  <StyledParagraphSmall>
                    v2food’s products accelerate consumers’ transition to a more
                    plant-rich diet and reduces greenhouse gas emissions, water
                    use and land use in our environment.
                  </StyledParagraphSmall>
                </Fade>
              </Col>
              <Col xs={12} lg={6}>
                <Fade ssrReveal right delay={300}>
                  <StaticImage
                    src="../../images/old-man-using-phone.png"
                    alt="old man using phone"
                    layout="fullWidth"
                  />

                  <StyledParagraphSmall>
                    CD Finance supports financial inclusion by providing access
                    to safe and affordable financial solutions to rural
                    communities in China.
                  </StyledParagraphSmall>
                </Fade>
              </Col>
            </Row>
          </Container>
        </Visible>
      </div>
      <Visible lg xl xxl>
        <StyledGeographyLinesAbsoluteContainer>
          <StyledGeographyLinesWrapper>
            <Fade ssrReveal delay={400}>
              <StaticImage
                src="../../images/geography-lines-1.png"
                alt="geography lines"
                layout="fullWidth"
              />
            </Fade>
          </StyledGeographyLinesWrapper>
        </StyledGeographyLinesAbsoluteContainer>
      </Visible>
    </section>
  )
}

export default CaseStudiesSection
